import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
/**
 * 后台系统增加 环境区分标识
 * 重写参考sentry https://github.com/getsentry/sentry-javascript/blob/5.15.5/packages/utils/src/instrument.ts
 * 环境标识模块，接入使用请参考：<a href="https://dashen.zhuanspirit.com/pages/viewpage.action?pageId=528091668" target="_blank">后台环境标识</a>
 * @module environmentTag
 */

import url from "./url";
var xhrProto;
var currentEnvir;
var clickHistory;
var isModalVisible = false;
var $modal_dissting_environment = null;
var firstFetchOfFirstDomain = '';
var domainMap = {};
if (typeof window !== 'undefined') {
  //兼容测试小工具 https://gitlab.zhuanspirit.com/zz-fe-common/xhr-proxy-script/-/tree/master
  //window._zzrxhr?.prototype 为原生xhr
  currentEnvir = null;
  clickHistory = [];
  xhrProto = window._zzrxhr && window._zzrxhr.prototype || window.XMLHttpRequest.prototype;
}

/**
 * 重写对象上的属性
 * @method fill
 * @param {Object} source 需要被重写的对象
 * @param {String} name 需要被重写的属性
 * @param {Function} replacement 重写后的方法
 */
var fill = function fill(source, name, replacement) {
  if (!(name in source)) {
    return;
  }
  var original = source[name];
  var wrapped = replacement(original);
  source[name] = wrapped;
};

// 将驼峰属性转为标准样式属性
var styleObjToString = function styleObjToString(styleObj) {
  return Object.keys(styleObj).reduce(function (pre, key) {
    var kebabCaseKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
    return "".concat(pre).concat(kebabCaseKey, ":").concat(styleObj[key], ";");
  }, '');
};

// 截取接口？之前，最后一个/之后
var extractUrlParts = function extractUrlParts(url) {
  var index = url.lastIndexOf('/');
  var lastSegment = url.substring(index + 1);
  var questionMarkIndex = lastSegment.indexOf('?');
  if (questionMarkIndex !== -1) {
    lastSegment = lastSegment.substring(0, questionMarkIndex);
  }
  return lastSegment;
};
var commonStyle = {
  position: 'fixed',
  width: '350px',
  maxHeight: '200px',
  backgroundColor: '#ffffff',
  borderRadius: '4px',
  boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
  color: '#111111',
  overflowY: 'auto',
  zIndex: '9999',
  display: 'none',
  lineHeight: '25px',
  padding: '10px',
  fontSize: '13px',
  top: '90px',
  left: '21px'
};
/**
 *
 * @method createEnvironDom
 * @param  { Object } param 配置参数
 * @param  { String } curentdom 需要插入的dom，
 * @param  {  Boolean } isNewStyle 必填，是否升级了规范 
 * @return { Promise }
 *
 */
/** 生成环境标识的dom结构 */
var createEnvironDom = function createEnvironDom(curentdom, isNewStyle) {
  var environments = {
    teststable: '稳定测试环境',
    sandboxstable: '稳定沙箱环境',
    test: '测试环境',
    sandbox: '沙箱环境',
    online: '线上环境'
  };
  var environmentText;
  var isTesting = function isTesting(env) {
    return env !== 'teststable' && env !== 'sandboxstable' && !env.includes('sandbox');
  };
  var isSandbox = function isSandbox(env) {
    return env !== 'sandboxstable' && env.includes('sandbox') && env !== 'teststable';
  };
  if (currentEnvir != 'undefinedNull' && isTesting(currentEnvir)) {
    environmentText = environments['test'];
  } else if (currentEnvir != 'undefinedNull' && isSandbox(currentEnvir)) {
    environmentText = environments['sandbox'];
  } else if (currentEnvir === 'teststable') {
    environmentText = environments['teststable'];
  } else if (currentEnvir === 'sandboxstable') {
    environmentText = environments['sandboxstable'];
  } else if (currentEnvir == 'undefinedNull') {
    environmentText = environments['online'];
  }
  console.log(environmentText, 'environmentText');
  environmentText = "\u5F53\u524D\u73AF\u5883\uFF1A".concat(environmentText);
  // 如果同时存在 fetch 和 XMLHttpRequest请求，避免渲染多个 dom
  if (!document.querySelector('.pc-distring-environment')) {
    var $parentEl = document.createElement('div');
    $parentEl.innerHTML = isNewStyle ? '<img src="https://pic4.zhuanstatic.com/zhuanzh/396722ef-5675-4ff1-a597-85ee9b9bc16e.png" style="height: 14px;margin-right:4px;">' + environmentText : '<img src="https://pic2.zhuanstatic.com/zhuanzh/5a1a282f-7fad-4a59-8f86-34f6e41ab6cf.png" style="height: 14px;margin-right:4px;">' + environmentText;
    $parentEl.className = 'pc-distring-environment';
    $parentEl.style.color = isNewStyle ? '#297afb' : '#ffffff';
    // $parentEl.style.marginLeft = '15px';
    $parentEl.style.cursor = 'pointer';
    $parentEl.style.padding = '2px 10px';
    $parentEl.style.margin = isNewStyle ? '10px auto 0 auto' : '0px auto';
    $parentEl.style.width = '194px';
    $parentEl.style.display = 'flex';
    $parentEl.style.alignItems = 'center';
    $parentEl.style.borderRadius = '4px';
    $parentEl.style.justifyContent = 'center';
    $parentEl.style.backgroundColor = isNewStyle ? '#e6f3fe' : '#273748';
    var $modalDissting = document.createElement('div');
    $modalDissting.className = 'modal-distring-environment';
    $modalDissting.style.cssText = styleObjToString(commonStyle);
    $parentEl.appendChild($modalDissting);
    observeDom(curentdom, $parentEl);
  }
};
var observeDom = function observeDom(currentDomSelector, ele) {
  var observerDom = new MutationObserver(function (mutations) {
    // 使用 `forEach` 避免在循环中调用 `disconnect`
    mutations.forEach(function (mutation) {
      var _logoDiv$;
      if (mutation && !document.querySelector('.pc-distring-environment')) {
        // 检查是否已存在环境标记DOM，避免重复插入
        var targetDiv = currentDomSelector ? document.querySelector(currentDomSelector) : document.querySelector('div#logo');
        if (targetDiv) {
          // 插入DOM并停止观察
          currentDomSelector ? targetDiv === null || targetDiv === void 0 ? void 0 : targetDiv.appendChild(ele) : targetDiv.insertAdjacentElement('afterend', ele);
          observerDom.disconnect();
        }
      }
      // 兼容折叠的时候环境标识样式
      var logoDiv = document.getElementsByClassName('ant-pro-sider');
      if (logoDiv && document.querySelector('.pc-distring-environment') && parseInt((_logoDiv$ = logoDiv[0]) === null || _logoDiv$ === void 0 || (_logoDiv$ = _logoDiv$.style) === null || _logoDiv$ === void 0 ? void 0 : _logoDiv$.width, 10) < 100) {
        document.querySelector('.pc-distring-environment').style.height = '30px';
        document.querySelector('.pc-distring-environment').style.padding = '0';
        document.querySelector('.pc-distring-environment').style.overflow = 'hidden';
        document.querySelector('.pc-distring-environment').style.width = 'auto';
      } else {
        if (document.querySelector('.pc-distring-environment')) {
          document.querySelector('.pc-distring-environment').style.height = 'auto';
          document.querySelector('.pc-distring-environment').style.padding = '2px 10px';
          document.querySelector('.pc-distring-environment').style.overflow = 'auto';
          document.querySelector('.pc-distring-environment').style.width = '194px';
        }
      }
    });
  });
  var observerConfig = {
    attributes: true,
    childList: true,
    subtree: true
  };
  observerDom.observe(document.body, observerConfig);

  // 如果初始时 targetDiv 已经存在，立即执行插入
  if (currentDomSelector && document.querySelector(currentDomSelector) || document.querySelector('div#logo')) {
    observerDom.takeRecords(); // 清空记录，避免重复执行
  }
};

// 监听路由切换重置弹窗
window.onhashchange = function () {
  // 当路由发生变化时执行的代码
  var newHash = window.location.hash;
  if (newHash) {
    $modal_dissting_environment = document.querySelector('.modal-distring-environment');
    // 切换路由的时候重置一下弹窗的显示，防止有问题
    if ($modal_dissting_environment) {
      $modal_dissting_environment.style.display = 'none';
      $modal_dissting_environment.style.visibility = 'hidden';
      $modal_dissting_environment.innerHTML = '';
    }
    // 只需要当前菜单的接口
    clickHistory = [];
    isModalVisible = false;
  }
};

// // 监听点击事件，用来显示和隐藏弹窗，因为dom更新有时候延迟，所以需要监听
document.addEventListener('click', function (event) {
  // 使用正确的选择器类名，这里假设 '.pc-distring-environment' 是触发显示/隐藏的元素
  if (event.target.closest('.pc-distring-environment')) {
    var modalDisstingEnvironment = document.querySelector('.modal-distring-environment');
    var hasContent = clickHistory.length > 0; // 检查是否有内容
    if (modalDisstingEnvironment) {
      // 仅在有内容时切换显示状态
      if (hasContent) {
        isModalVisible = !isModalVisible;

        // 根据当前状态设置 display 和 visibility
        modalDisstingEnvironment.style.display = isModalVisible ? 'block' : 'none';
        modalDisstingEnvironment.style.visibility = isModalVisible ? 'visible' : 'hidden';
      } else {
        // 如果没有内容，确保弹窗不显示
        modalDisstingEnvironment.style.display = 'none';
        modalDisstingEnvironment.style.visibility = 'hidden';
      }

      // 仅在切换为可见状态时设置 innerHTML
      if (isModalVisible) {
        modalDisstingEnvironment.innerHTML = clickHistory.join('');
      }
    }
  }
});

// 点击生成modal弹窗
var createModalData = function createModalData(current, url) {
  $modal_dissting_environment = document.querySelector('.modal-distring-environment');
  // 将满足条件的内容添加到点击历史记录数组中
  // 注意：这里有current == undefinednull,代表返回没有global-tag这个字段，代表是线上环境
  if (window.localStorage.getItem('currentEnvironmentTag') && window.localStorage.getItem('currentEnvironmentTag') != current) {
    var content = '接口' + extractUrlParts(url) + '与当前环境不一致' + '<br>';
    if (!clickHistory.includes(content)) {
      clickHistory.push(content);
    }
  }
};
var transformSubdomain = function transformSubdomain(originalUrl, domain) {
  var hostname = new URL(originalUrl).hostname;
  // 兼容泛域名并且排除谛听接口，因为谛听接口比较特殊
  var modifiedUrl = originalUrl.replace(/-[^.]+\.[^.]*/, '');
  return hostname.includes('-') ? modifiedUrl : originalUrl;
};

/**
 * 生成dom
 * 并且将dom挂载到默认位置或者自定义的位置
 * @method createDom
 */

// 拿到第一个请求的global-route-tag，存下来
var createDom = function createDom(globalTag, responseURL, currentDom) {
  var _domainMap;
  var isNewStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var targetDomain = domainMap.has(new URL(responseURL).hostname) && new URL(responseURL).hostname;
  var domains = _toConsumableArray((_domainMap = domainMap) === null || _domainMap === void 0 ? void 0 : _domainMap.keys());
  var firstDomain = domains[0];
  if (targetDomain && firstDomain === targetDomain && domainMap.get(firstDomain) === 0 && !responseURL.includes('dev-serve')) {
    // 检查是否是数组中的第一个域名
    firstFetchOfFirstDomain = firstDomain;
    currentEnvir = globalTag ? globalTag : 'undefinedNull'; // 此处使用正确的变量名 currentDom 替换 curentdom
    window.localStorage.setItem('currentEnvironmentTag', currentEnvir);
    try {
      createEnvironDom(currentDom, isNewStyle); // 使用正确的变量名 currentDom
    } catch (error) {
      console.log(error, 'error');
    }
  }
  var targetDomainCount = domainMap.get(targetDomain); // 仅当是第一个请求时才增加计数
  domainMap.set(targetDomain, targetDomainCount + 1);
  // 其他逻辑保持不变
  if (targetDomain && responseURL.includes(targetDomain) && !responseURL.includes('dev-serve')) {
    createModalData(globalTag ? globalTag : 'undefinedNull', responseURL);
  }
};
/**
 * 初始化
 * @method initDom
 * @param  { Object } param 配置参数
 * @param  { Array } domain 需要检测的域名，
 * @param  { String } insertDefaultDomClassOrID 需要插入的dom，
 * @param  { Boolean } isNewStyle 必填，是否升级了规范 
 * @return { Promise }
 *
 */

var initDom = function initDom(_ref) {
  var domain = _ref.domain,
    insertDefaultDomClassOrID = _ref.insertDefaultDomClassOrID,
    isNewStyle = _ref.isNewStyle;
  domainMap = new Map(domain === null || domain === void 0 ? void 0 : domain.map(function (item) {
    return [item, 0];
  }));
  var _url$getParams = url === null || url === void 0 ? void 0 : url.getParams(window.location.href || ''),
    hideSider = _url$getParams.hideSider,
    hideSidebar = _url$getParams.hideSidebar;
  fill(xhrProto, 'send', function (originalSend) {
    return function () {
      //类数组转数组
      var args = [].slice.call(arguments);
      //xhr为实例
      var xhr = this;
      xhr.addEventListener('readystatechange', function () {
        // debugger
        if (xhr.readyState === 4) {
          try {
            var globalTag = xhr.getResponseHeader('global-route-tag');
            // 为了支持泛域名
            var responseURL = transformSubdomain(xhr.responseURL, domain);
            // console.log(url.getParams('https://d.zhuanspirit.com/trade/promotion_manage/index.html?apiHost=ptyy.zhuanspirit.com&hideSidebar=1&tt=1720682146519#/activity'), 'hideSidebar');
            // const url = 'https://scp.zhuanspirit.com/?hideSider=1&parentSys=zzerp#/purchase-management/purchase-order-edit'
            // 兼容iframe的场景
            if (hideSider && +hideSider === 1 || hideSidebar && +hideSidebar === 1) {} else {
              createDom(globalTag, responseURL, insertDefaultDomClassOrID, isNewStyle);
            }
          } catch (e) {
            /* do nothing */
          }
        }
      });
      //执行原有send函数
      return originalSend.apply(this, args);
    };
  });
  fill(window, 'fetch', function (originalFetch) {
    return function () {
      var args = [].slice.call(arguments);
      return originalFetch.apply(window, args).then(function (response) {
        //respone.clone复制一个新的流，因为respone.json一个流只能使用一次
        //https://stackoverflow.com/questions/53511974/javascript-fetch-failed-to-execute-json-on-response-body-stream-is-locked
        response.clone().json().then(function () {
          try {
            var globalTag = response.headers.get('global-route-tag');
            var responseURL = transformSubdomain(args[0], domain);
            if (hideSider && +hideSider === 1 || hideSidebar && +hideSidebar === 1) {} else {
              createDom(globalTag, responseURL, insertDefaultDomClassOrID, isNewStyle);
            }
          } catch (e) {
            /* do nothing */
          }
        });
        return response;
      }, function (error) {
        throw error;
      });
    };
  });
};
export default {
  initDom: initDom
};